/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Studio_BrushInputs */

const en_landing_studio_brush = /** @type {(inputs: Landing_Studio_BrushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Brush`)
};

const zh_landing_studio_brush = /** @type {(inputs: Landing_Studio_BrushInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`画笔`)
};

/**
* | output |
* | --- |
* | "Brush" |
*
* @param {Landing_Studio_BrushInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_studio_brush = /** @type {((inputs?: Landing_Studio_BrushInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Studio_BrushInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_studio_brush(inputs)
	return zh_landing_studio_brush(inputs)
});
export { landing_studio_brush as "landing.studio.brush" }